import {PerformanceLogger} from '../performance';
import {ENVIRONMENT_LEVEL} from '@/Constant';
import {LOG_DOC_TYPE, LogDocType} from './const';

export class EditorCrash {
    key = 'EditorCrash';
    logger: PerformanceLogger | null = null;
    constructor(logger: PerformanceLogger) {
        this.logger = logger;
    }

    // 文档白屏上报
    logWeb = (error: Error, docType?: LogDocType) => {
        const logger = this.logger;
        const logLevel = logger?.logLevel || '';
        if ([ENVIRONMENT_LEVEL.online, ENVIRONMENT_LEVEL.gray, ENVIRONMENT_LEVEL.qa].includes(logLevel)) {
            logger?.feLogger({
                id: '80001.2.11',
                data: {
                    message: error.message,
                    docType: docType || LOG_DOC_TYPE.doc,
                },
            });
        }
    };

}
